import React from 'react';
import PropTypes from 'prop-types';
import NameIcon from './name_icon.js.jsx';
import string_to_colour from '../string_to_colour.js'
export default class PartyMessage extends React.Component {
  render() {
    if (this.props.data.party.system_msg)
      return (
        <li className="left clearfix">
            <small className="pull-right text-muted" title={moment(this.props.data.sent_at).format('MMMM Do YYYY, h:mm:ss a, Z')}>
                {moment(this.props.data.sent_at).locale(this.props.locale).fromNow()}
            </small>
            <div className="text-muted">
                <em><small>{this.props.data.message}</small></em>
            </div>
        </li>
      );

    return (
      <li className="left clearfix">
        <span className="chat-img pull-left">
	  <NameIcon letter={this.props.data.party.party_name[0]} backgroundColor={"#" + string_to_colour(this.props.data.party.party_name + this.props.data.party.name)}/>
          <img src={'https://via.placeholder.com/40/' + string_to_colour(this.props.data.party.party_name + this.props.data.party.name) + '/ffffff?txtsize=30&text=' + this.props.data.party.party_name[0]} alt={this.props.data.party.party_name} className="img-circle" />
        </span>
        <div className="chat-body clearfix">
          <div className="header">
            <strong><small>{this.props.data.party.party_name}</small></strong>
            <small className="pull-right text-muted" title={moment(this.props.data.sent_at).format('MMMM Do YYYY, h:mm:ss a, Z')}>
              {moment(this.props.data.sent_at).locale(this.props.locale).fromNow()}
            </small>
          </div>
          <p><small className="preserve-whitespace">{this.props.data.message}</small></p>
        </div>
      </li>
    );
  }
}

PartyMessage.propTypes = {
    message: PropTypes.string,
    sent_by: PropTypes.string,//React.PropTypes.instanceOf(Party),
    sent_at: PropTypes.string,
    published: PropTypes.bool
}

